import { memo } from 'react';
import React from 'react';

import { SpaceBetween, Popover, StatusIndicator, Button, Box } from '@amzn/awsui-components-react-v3';

import ScanInput from 'src/components/ScanInput';
import { ValueWithLabel } from 'src/components/Utils';

interface BuildIDComponentProps {
  disabled: boolean;
  handleBuildIdChange: (val: string) => void;
  buildId?: string;
  show: boolean;
}

export const BuildIDComponent = memo(({ disabled, handleBuildIdChange, buildId, show }: BuildIDComponentProps) => {
  if (!show) {
    return null;
  }

  return (
    <ValueWithLabel
      label={
        <SpaceBetween direction="horizontal" size="xxxs">
          <Popover
            dismissButton={false}
            position="top"
            size="small"
            triggerType="custom"
            content={<StatusIndicator type="info">Reason for using Inventory Adjustment</StatusIndicator>}
          >
            <Button ariaLabel="receiving-model-buildId" iconName="status-info" variant="icon" />
          </Popover>
          <Box variant="awsui-key-label">Build ID</Box>
          <Box variant="span" color="text-status-error">
            *
          </Box>
        </SpaceBetween>
      }
    >
      <Box margin={{ left: 'l' }}>
        <ScanInput
          onChange={(val) => handleBuildIdChange(val)}
          onScan={(val) => handleBuildIdChange(val)}
          inputValue={buildId}
          placeholder="Build ID"
          disabled={disabled}
        />
      </Box>
    </ValueWithLabel>
  );
});
